<template>
    <div class="container mx-auto max-w-6xl">
        <div class="start-tracking">
            <div class="flex justify-between items-center">
                <div class="flex items-center gap-2">
                    <icon icon="credit-score" class="text-black" />
                    <span class="text-lg font-medium text-slate-800">Credit Score</span>
                </div>
                <a href="/credit-score/" class="flex items-center text-sm font-medium rounded text-slate-800 hover:text-slate-700 active:text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-0">
                    View Details
                    <icon icon="arrow" />
                </a>
            </div>
            <div class="rx m-16">
                <div class="text-center px-4 mt16">
                    <div class="flex items-center justify-center rounded-full mb-4">
                        <div class="flex w-16 h-16 p-4 justify-center items-center rounded-full bg-[#E2E8F0]">
                            <icon icon="credit-score" class="text-slate-800" :width="32" :height="32" />
                        </div>
                    </div>
                    <h2 class="text-lg text-slate-800 font-medium">No credit score info yet</h2>
                    <div class="mb-6 relative">
                        <p class="text-sm font-normal text-slate-500">
                            Add your credit score to start tracking your credit
                        </p>
                    </div>
                    <a
                        href="#"
                        class="h-9 px-4 py-2 rounded justify-start items-start gap-2 inline-flex hover:text-slate-700 active:text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-0"
                        @click.prevent="openCreditScoreModal"
                        role="button"
                    >
                        <icon icon="plus" class="text-slate-800"/>
                        <span class="font-medium text-sm text-slate-800">Add credit score</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCreditScoreStore } from '@/store/creditscore';
import Icon from '../ui/icon/icon.vue';

export default {
    components: { Icon },
    props: {
        onDashboard: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({}),
    directives: {},
    computed: {
        ...mapState(useCreditScoreStore, ['userScoreData']),
    },
    methods: {
        ...mapActions(useCreditScoreStore, ['setTabState', 'openCreditScoreModal']),
    },
    mounted() {},
};
</script>


<style lang="scss" scoped>
.custom-icon-size {
    width: 32px !important;
    height: 32px !important;
}
</style>
